import { render, staticRenderFns } from "./PFLoanFiscalReport.vue?vue&type=template&id=70f77c85"
import script from "./PFLoanFiscalReport.vue?vue&type=script&lang=js"
export * from "./PFLoanFiscalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports